/* eslint-disable import/first */
// Process polyfill for environment variables in the browser
window.process = window.process || {};
window.process.env = window.process.env || {};

import React from 'react';
import ReactDOM from 'react-dom/client';
import { FirebaseProvider } from './contexts/FirebaseContext';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <FirebaseProvider>
        <App />
    </FirebaseProvider>
);